import CSRCountryModel from './CSRCountryModel';

export default class CSRCountryCollection {
  constructor(options) {
    this.endpoint = options.endpoint;
  }

  fetchData() {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', this.endpoint);
      xhr.onload = () => {
        this.data = JSON.parse(xhr.responseText);
        this.parseData(this.data);
        resolve(this.data);
      };
      xhr.onerror = () => resolve(xhr.statusText);
      xhr.send();
    });
  }

  parseData(data) {
    this.countries = {};
    const countries = data.worldwide_countries;
    let country;
    for (let i = 0, leni = countries.length; i < leni; i++) {
      country = countries[i];
      this.countries[country.country_code] = new CSRCountryModel({
        data: country,
      });
    }
  }

  getModelForCountry(country) {
    return this.countries[country] || false;
  }

  getCountriesForProduct(product) {
    let country;
    const countryArray = [];
    const countries = this.data.worldwide_countries;
    for (let i = 0, leni = countries.length; i < leni; i++) {
      country = countries[i];
      if (this.checkCountryFactoryCreatesProduct(country.country_factories, product)) {
        countryArray.push(country.country_code);
      }
    }
    return countryArray;
  }

  getFactoryDataForId(id) {
    let factoryModel;
    for (const c in this.countries) {
      factoryModel = this.countries[c].getFactoryModelForId(id);
      if (factoryModel) {
        return { model: factoryModel, country: this.countries[c] };
      }
    }
    return false;
  }

  checkCountryFactoryCreatesProduct(factories, product) {
    return factories.some(
      factory =>
        factory.factory_data.product_types &&
        this.checkFactoryCreatesProduct(
          factory.factory_data.product_types.product_type_name,
          product
        )
    );
  }

  checkFactoryCreatesProduct(products, product) {
    return products.some(val => val === product);
  }
}
